// constants/roles.js
// import dotenv from "dotenv";
// dotenv.config();
// console.log("📢📢check dotenv in client: ", process.env.ADMIN_LOGIN_ID);

export const ADMIN_LOGIN_ID = '108187272260400998451';
export const ADMIN_NAME = 'ProfiX Admin';